import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" data-discover="true" className="flex items-center space-x-2" itemScope itemType="https://schema.org/Organization">
            <img src="/images/favicon.webp" alt="ParisPari Hub" className="w-10 h-10" itemProp="logo" />
            <span className="text-2xl font-bold text-gray-900" itemProp="name">ParisPari Hub</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" data-discover="true" className="text-gray-700 hover:text-primary-red transition-colors">
              Accueil
            </Link>
            <Link to="/guides" data-discover="true" className="text-gray-700 hover:text-primary-red transition-colors">
              Guides
            </Link>
            <Link to="/reviews" data-discover="true" className="text-gray-700 hover:text-primary-red transition-colors">
              Avis
            </Link>
            <Link to="/news" data-discover="true" className="text-gray-700 hover:text-primary-red transition-colors">
              Actualités
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-primary-red"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                data-discover="true"
                className="text-gray-700 hover:text-primary-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Accueil
              </Link>
              <Link
                to="/guides"
                data-discover="true"
                className="text-gray-700 hover:text-primary-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Guides
              </Link>
              <Link
                to="/reviews"
                data-discover="true"
                className="text-gray-700 hover:text-primary-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Avis
              </Link>
              <Link
                to="/news"
                data-discover="true"
                className="text-gray-700 hover:text-primary-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Actualités
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

